import { PulsePin } from '@umanforge/common';
import { forwardRef, ForwardedRef, useState, ChangeEvent, KeyboardEvent } from 'react';

interface ColorPickerProp {
  value: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: ( value: string ) => void;
  onBlur?: ( value: string ) => void;
  onKeyEnterUp?: ( event: KeyboardEvent ) => void;
};

export const ColorPicker = forwardRef( function ColorPicker( { value, label, onChange, onBlur, onKeyEnterUp, required = false, disabled = false }: ColorPickerProp, ref: ForwardedRef<HTMLInputElement> ) {
  const [ isFocus, setIsFocus ] = useState<boolean>( false );
  const [ inputValue, setInputValue ] = useState<string>( value );


  return (
    <div className='flex flex-col gap-[2px] w-full'>
      <p className='flex gap-1 ml-1 items-center text-base'>
        {label}
      </p>
      <div className='relative'>
        <div
          className={
            'flex w-full h-9 items-center rounded-lg outline min-w-9 overflow-hidden ' +
            ( isFocus ? 'outline-2 outline-gray-base-dark bg-off-white ' : 'outline-1 outline-gray-base ' ) +
            ( disabled ? 'bg-stone-100 text-gray-600' : 'hover:outline-gray-base-dark hover:bg-off-white text-black' )
          }
        >
          <input
            type='color'
            required={ required }
            disabled={ disabled }
            ref={ ref }
            value={ inputValue }
            className={
              'w-full h-full select-none caret-secondary bg-transparent ' +
              ( disabled ? 'cursor-default' : 'cursor-pointer' )
            }
            onFocus={ () => { setIsFocus( !disabled && true ); } }
            onBlur={ () => {
              if ( onBlur != undefined ) {
                onBlur( inputValue );
              }
              setIsFocus( false );
            } }
            onChange={ ( event: ChangeEvent ) => {
              const color = ( event.target as HTMLInputElement ).value.toUpperCase();
              if ( inputValue != null ) {
                setInputValue( color );
              }
              if ( onChange != undefined ) {
                onChange( color );
              }
            } }
            onKeyUp={ event => {
              if ( event.key === 'Enter' ) {
                if ( onKeyEnterUp != undefined ) {
                  onKeyEnterUp( event );
                  ( event.target as HTMLInputElement ).blur();
                }
              }
            } }
          />
        </div>
        <PulsePin isDisplay={ required && ( inputValue == null || inputValue == '' ) } isPulse={ isFocus } />
      </div>
    </div>
  );
} );